module.exports = __webpack_public_path__ + "media/images/athletes/4157-768aac200273de9562654d61d7afd0b3.png";